const productionSettings = {
  SENTRY_DSN: 'https://9c4df485116d4051adee5543193eeac3@app.getsentry.com/24119',
};

const developmentSettings = {
  SENTRY_DSN: 'https://663da0655fda48dd9e79d5d4b0d9d6bd@app.getsentry.com/23944',
};

const settings = process.env.NODE_ENV === 'production' ? productionSettings : developmentSettings;

export default settings;



// WEBPACK FOOTER //
// ../globals/settings.js